import React from "react";

const FooterMobile: React.FC = () => {
  return (
    <footer className="bg-riama-blue text-riama-white py-6">
      <div className="container mx-auto px-4 text-center space-y-4">
        {/* Sezione Contatti */}
        <div className="text-sm space-y-1">
          <p className="font-bold text-lg">Contatti</p>
          <p>Telefono: +39 392 403 5929</p>
          <p>
            Email:{" "}
            <a
              href="mailto:riama.olistica@gmail.com"
              className="underline hover:text-riama-orange"
            >
              riama.olistica@gmail.com
            </a>
          </p>
          <p>Indirizzo: Via D'Azeglio 35, Bologna</p>
          <hr className="my-4" />
          <a
            href="https://instagram.com/riama.olistica"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-riama-orange flex flex-row justify-center"
          >
            Seguimi su Instagram&nbsp;&nbsp;
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.35 3.608 1.325.975.975 1.263 2.242 1.325 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.35 2.633-1.325 3.608-.975.975-2.242 1.263-3.608 1.325-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.35-3.608-1.325-.975-.975-1.263-2.242-1.325-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.35-2.633 1.325-3.608.975-.975 2.242-1.263 3.608-1.325 1.266-.058 1.646-.07 4.85-.07zm0-2.163c-3.259 0-3.67.014-4.947.072-1.531.07-2.94.428-4.019 1.507C2.437 2.98 2.08 4.389 2.01 5.92c-.058 1.277-.072 1.688-.072 4.947s.014 3.67.072 4.947c.07 1.531.428 2.94 1.507 4.019 1.079 1.079 2.488 1.437 4.019 1.507 1.277.058 1.688.072 4.947.072s3.67-.014 4.947-.072c1.531-.07 2.94-.428 4.019-1.507 1.079-1.079 1.437-2.488 1.507-4.019.058-1.277.072-1.688.072-4.947s-.014-3.67-.072-4.947c-.07-1.531-.428-2.94-1.507-4.019C19.234 2.437 17.825 2.08 16.294 2.01 15.017 1.952 14.606 1.938 11.347 1.938zm0 5.838a6.207 6.207 0 1 0 0 12.414 6.207 6.207 0 1 0 0-12.414zm0 2.163a4.044 4.044 0 1 1 0 8.088 4.044 4.044 0 1 1 0-8.088zm6.406-.64a1.44 1.44 0 1 1 0-2.881 1.44 1.44 0 1 1 0 2.881z" />
            </svg>
          </a>
        </div>

        {/* Diritti d'autore */}
        <div className="text-xs">
          <p>© Mariateresa Carlucci - P. IVA: 04257851206 - 2025 RIAMA. Tutti i diritti riservati.</p>
          <p>Design by RIAMA</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterMobile;
